// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShowcaseSection_showcaseSection__eyosS {
  width: 100%;
  height: 100vh;
  padding: 0 0 0 0;
}

.ShowcaseSection_topRow__CaL6m {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 60px 8vw 0 8vw;
  min-height: 340px;
  animation: ShowcaseSection_fadeInUp__o1dJd 1.2s both;
}

.ShowcaseSection_personWrapper__1YtBN {
  position: relative;
  width: 260px;
  height: 260px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-top: 50px;
  perspective: 600px;
}

.ShowcaseSection_personBg__l7vhR {
  position: absolute;
  top: 30px;
  left: 0;
  width: 220px;
  height: 160px;
  background: #ffe36e;
  border-radius: 50% 40% 60% 40%/60% 40% 60% 40%;
  z-index: 1;
  opacity: 0.85;
}

.ShowcaseSection_blinkingCircles__y\\+kuh {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  z-index: 0;
  pointer-events: none;
}

.ShowcaseSection_circle__rQZjH {
  position: absolute;
  border: 12px solid #f9ebc6;
  border-radius: 50%;
  opacity: 0.5;
  animation: ShowcaseSection_blinkShowcase__rJ4t9 2s infinite alternate;
}

.ShowcaseSection_circle__rQZjH:nth-child(1) {
  width: 200px;
  height: 200px;
  top: 20%;
  left: -30%;
  border-color: orange;
  animation-delay: 0.9s;
}

.ShowcaseSection_circle__rQZjH:nth-child(2) {
  width: 180px;
  height: 180px;
  top: 70%;
  left: 70%;
  border-color: #c45bae;
  animation-delay: 0.7s;
}

.ShowcaseSection_circle__rQZjH:nth-child(3) {
  width: 150px;
  height: 150px;
  top: 90%;
  left: 30%;
  border-color: #6bc6c6;
  animation-delay: 1.2s;
}

@keyframes ShowcaseSection_blinkShowcase__rJ4t9 {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.1;
  }
}
.ShowcaseSection_personImg__-txzA {
  position: relative;
  top: 10%;
  width: 360px;
  height: 371px;
  object-fit: cover;
  z-index: 2;
  border-radius: 18px;
  transition: transform 0.3s cubic-bezier(0.4, 0.2, 0.2, 1);
}

.ShowcaseSection_screenshotWrapper__TN-U3 {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-left: 40px;
}

.ShowcaseSection_screenshotImg__t0rd4 {
  width: 733px;
  height: 366px;
  max-width: 100%;
  border-radius: 16px;
  box-shadow: 0 4px 32px rgba(6, 190, 188, 0.13);
  border: 4px solid #6ee7e7;
}

.ShowcaseSection_partnersSection__q5IWl {
  padding: 80px 0 36px 0;
  background-color: #232827;
  margin-top: 9.25rem;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.ShowcaseSection_partnersTitle__Q9K8F {
  font-size: 20px;
  font-style: italic;
  font-weight: 500;
  margin-bottom: 32px;
  color: #222;
}

.ShowcaseSection_partnersRow__qY6PP {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  background-color: #eee;
  position: relative;
  width: 100%;
  min-height: 50px;
}

.ShowcaseSection_partnersRowInner__ROYsB {
  display: flex;
  align-items: center;
  gap: 5rem;
  animation: ShowcaseSection_marquee__71wTS 138s linear infinite;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_socarTerminalImg__luEkz {
  width: 110px;
  height: 110px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_starRafineriImg__gaN4t {
  width: 130px;
  height: 130px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_togImg__SjsQk {
  width: 100px;
  height: 100px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_azImg__XTQ3B {
  width: 80px;
  height: 80px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_tkhImg__UZ4xb {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_stateTaxImg__loM-z {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_bereketSigortaImg__IQt7M {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_bigaHomeImg__BRxs1 {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_biotrendImg__1PHwg {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_doganlarHoldingImg__oma78 {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_doganlarMobilyaImg__1uwXW {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_dogtasImg__L-vwN {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_gubretasImg__9YraY {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_kelebekImg__Bv7hC {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_lovaImg__1RobV {
  width: 120px;
  height: 120px;
}
.ShowcaseSection_partnersRowInner__ROYsB .ShowcaseSection_ruumStoreImg__5gYqM {
  width: 120px;
  height: 120px;
}

@keyframes ShowcaseSection_marquee__71wTS {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.ShowcaseSection_partnersRow__qY6PP img {
  height: 40px;
  object-fit: contain;
  filter: grayscale(0.2);
  opacity: 0.95;
  flex-shrink: 0;
}

@keyframes ShowcaseSection_fadeInUp__o1dJd {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 900px) {
  .ShowcaseSection_topRow__CaL6m {
    flex-direction: column;
    align-items: center;
    padding: 40px 2vw 0 2vw;
  }
  .ShowcaseSection_personWrapper__1YtBN {
    width: 180px;
    height: 180px;
    margin-bottom: 24px;
  }
  .ShowcaseSection_personBg__l7vhR {
    width: 150px;
    height: 100px;
    top: 20px;
  }
  .ShowcaseSection_personImg__-txzA {
    width: 150px;
    height: 160px;
  }
  .ShowcaseSection_screenshotWrapper__TN-U3 {
    padding-left: 0;
    justify-content: center;
    width: 100%;
    margin-bottom: 24px;
  }
  .ShowcaseSection_screenshotImg__t0rd4 {
    width: 98vw;
    max-width: 350px;
  }
  .ShowcaseSection_partnersSection__q5IWl {
    padding: 32px 0 24px 0;
    margin-top: 16px;
  }
  .ShowcaseSection_partnersRow__qY6PP {
    gap: 18px;
    min-height: 32px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .ShowcaseSection_partnersRow__qY6PP::-webkit-scrollbar {
    display: none;
  }
  .ShowcaseSection_partnersRowInner__ROYsB {
    gap: 18px;
    animation: ShowcaseSection_marquee__71wTS 135s linear infinite;
    flex-shrink: 0;
    min-width: max-content;
  }
  .ShowcaseSection_partnersRow__qY6PP img {
    height: 28px;
  }
}
.ShowcaseSection_contentAnimate__K5Rqt {
  opacity: 0;
  transform: translateY(100px) scale(0.85);
  transition: opacity 0.7s cubic-bezier(0.4, 0, 0.2, 1), transform 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity, transform;
  transform-origin: bottom center;
}

.ShowcaseSection_contentAnimate__K5Rqt.ShowcaseSection_inView__WoveH {
  opacity: 1;
  transform: translateY(0) scale(1);
}`, "",{"version":3,"sources":["webpack://./src/components/ShowcaseSection/ShowcaseSection.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oDAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8CAAA;EACA,UAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,UAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,qEAAA;AACF;;AACA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EAEA,qBAAA;AACF;;AACA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,qBAAA;AAEF;;AAAA;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;EACA,qBAAA;AAGF;;AAAA;EACE;IACE,YAAA;EAGF;EADA;IACE,YAAA;EAGF;AACF;AAAA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,yDAAA;AAEF;;AACA;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AAEF;;AACA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,yBAAA;AAEF;;AACA;EACE,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAEF;;AACA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EAEA,SAAA;EAEA,8DAAA;AAAF;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;AAEE;EACE,YAAA;EACA,aAAA;AAAJ;;AAIA;EACE;IACE,wBAAA;EADF;EAGA;IACE,2BAAA;EADF;AACF;AAIA;EACE,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;AAFF;;AAKA;EACE;IACE,UAAA;IACA,2BAAA;EAFF;EAIA;IACE,UAAA;IACA,wBAAA;EAFF;AACF;AAKA;EACE;IACE,sBAAA;IACA,mBAAA;IACA,uBAAA;EAHF;EAKA;IACE,YAAA;IACA,aAAA;IACA,mBAAA;EAHF;EAKA;IACE,YAAA;IACA,aAAA;IACA,SAAA;EAHF;EAKA;IACE,YAAA;IACA,aAAA;EAHF;EAKA;IACE,eAAA;IACA,uBAAA;IACA,WAAA;IACA,mBAAA;EAHF;EAKA;IACE,WAAA;IACA,gBAAA;EAHF;EAKA;IACE,sBAAA;IACA,gBAAA;EAHF;EAKA;IACE,SAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;IACA,iCAAA;IACA,qBAAA;IACA,wBAAA;EAHF;EAKE;IACE,aAAA;EAHJ;EAMA;IACE,SAAA;IACA,8DAAA;IACA,cAAA;IACA,sBAAA;EAJF;EAMA;IACE,YAAA;EAJF;AACF;AAOA;EACE,UAAA;EACA,wCAAA;EACA,kGAAA;EACA,+BAAA;EACA,+BAAA;AALF;;AAQA;EACE,UAAA;EACA,iCAAA;AALF","sourcesContent":[".showcaseSection {\n  width: 100%;\n  height: 100vh;\n  padding: 0 0 0 0;\n}\n\n.topRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 60px 8vw 0 8vw;\n  min-height: 340px;\n  animation: fadeInUp 1.2s both;\n}\n\n.personWrapper {\n  position: relative;\n  width: 260px;\n  height: 260px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  margin-top: 50px;\n  perspective: 600px;\n}\n\n.personBg {\n  position: absolute;\n  top: 30px;\n  left: 0;\n  width: 220px;\n  height: 160px;\n  background: #ffe36e;\n  border-radius: 50% 40% 60% 40% / 60% 40% 60% 40%;\n  z-index: 1;\n  opacity: 0.85;\n}\n\n.blinkingCircles {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  transform: translate(-50%, -50%);\n  z-index: 0;\n  pointer-events: none;\n}\n\n.circle {\n  position: absolute;\n  border: 12px solid #f9ebc6;\n  border-radius: 50%;\n  opacity: 0.5;\n  animation: blinkShowcase 2s infinite alternate;\n}\n.circle:nth-child(1) {\n  width: 200px;\n  height: 200px;\n  top: 20%;\n  left: -30%;\n  border-color: orange;\n\n  animation-delay: 0.9s;\n}\n.circle:nth-child(2) {\n  width: 180px;\n  height: 180px;\n  top: 70%;\n  left: 70%;\n  border-color: #c45bae;\n  animation-delay: 0.7s;\n}\n.circle:nth-child(3) {\n  width: 150px;\n  height: 150px;\n  top: 90%;\n  left: 30%;\n  border-color: #6bc6c6;\n  animation-delay: 1.2s;\n}\n\n@keyframes blinkShowcase {\n  0% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0.1;\n  }\n}\n\n.personImg {\n  position: relative;\n  top: 10%;\n  width: 360px;\n  height: 371px;\n  object-fit: cover;\n  z-index: 2;\n  border-radius: 18px;\n  transition: transform 0.3s cubic-bezier(0.4, 0.2, 0.2, 1);\n}\n\n.screenshotWrapper {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding-left: 40px;\n}\n\n.screenshotImg {\n  width: 733px;\n  height: 366px;\n  max-width: 100%;\n  border-radius: 16px;\n  box-shadow: 0 4px 32px rgba(6, 190, 188, 0.13);\n  border: 4px solid #6ee7e7;\n}\n\n.partnersSection {\n  padding: 80px 0 36px 0;\n  background-color: #232827;\n  margin-top: 9.25rem;\n  display: flex;\n  overflow-x: hidden;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.partnersTitle {\n  font-size: 20px;\n  font-style: italic;\n  font-weight: 500;\n  margin-bottom: 32px;\n  color: #222;\n}\n\n.partnersRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow: hidden;\n  background-color: #eee;\n  position: relative;\n  width: 100%;\n  min-height: 50px;\n}\n\n.partnersRowInner {\n  display: flex;\n  align-items: center;\n\n  gap: 5rem;\n  // duration scaled from 120s to keep marquee px/sec speed constant after adding 4 logos\n  animation: marquee 138s linear infinite;\n\n  .socarTerminalImg {\n    width: 110px;\n    height: 110px;\n  }\n  .starRafineriImg {\n    width: 130px;\n    height: 130px;\n  }\n  .togImg {\n    width: 100px;\n    height: 100px;\n  }\n  .azImg {\n    width: 80px;\n    height: 80px;\n  }\n  .tkhImg {\n    width: 120px;\n    height: 120px;\n  }\n  .stateTaxImg {\n    width: 120px;\n    height: 120px;\n  }\n  .bereketSigortaImg {\n    width: 120px;\n    height: 120px;\n  }\n  .bigaHomeImg {\n    width: 120px;\n    height: 120px;\n  }\n  .biotrendImg {\n    width: 120px;\n    height: 120px;\n  }\n  .doganlarHoldingImg {\n    width: 120px;\n    height: 120px;\n  }\n  .doganlarMobilyaImg {\n    width: 120px;\n    height: 120px;\n  }\n  .dogtasImg {\n    width: 120px;\n    height: 120px;\n  }\n  .gubretasImg {\n    width: 120px;\n    height: 120px;\n  }\n  .kelebekImg {\n    width: 120px;\n    height: 120px;\n  }\n  .lovaImg {\n    width: 120px;\n    height: 120px;\n  }\n  .ruumStoreImg {\n    width: 120px;\n    height: 120px;\n  }\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.partnersRow img {\n  height: 40px;\n  object-fit: contain;\n  filter: grayscale(0.2);\n  opacity: 0.95;\n  flex-shrink: 0;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 900px) {\n  .topRow {\n    flex-direction: column;\n    align-items: center;\n    padding: 40px 2vw 0 2vw;\n  }\n  .personWrapper {\n    width: 180px;\n    height: 180px;\n    margin-bottom: 24px;\n  }\n  .personBg {\n    width: 150px;\n    height: 100px;\n    top: 20px;\n  }\n  .personImg {\n    width: 150px;\n    height: 160px;\n  }\n  .screenshotWrapper {\n    padding-left: 0;\n    justify-content: center;\n    width: 100%;\n    margin-bottom: 24px;\n  }\n  .screenshotImg {\n    width: 98vw;\n    max-width: 350px;\n  }\n  .partnersSection {\n    padding: 32px 0 24px 0;\n    margin-top: 16px;\n  }\n  .partnersRow {\n    gap: 18px;\n    min-height: 32px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n  .partnersRowInner {\n    gap: 18px;\n    animation: marquee 135s linear infinite;\n    flex-shrink: 0;\n    min-width: max-content;\n  }\n  .partnersRow img {\n    height: 28px;\n  }\n}\n\n.contentAnimate {\n  opacity: 0;\n  transform: translateY(100px) scale(0.85);\n  transition: opacity 0.7s cubic-bezier(0.4, 0, 0.2, 1), transform 0.7s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: opacity, transform;\n  transform-origin: bottom center;\n}\n\n.contentAnimate.inView {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showcaseSection": `ShowcaseSection_showcaseSection__eyosS`,
	"topRow": `ShowcaseSection_topRow__CaL6m`,
	"fadeInUp": `ShowcaseSection_fadeInUp__o1dJd`,
	"personWrapper": `ShowcaseSection_personWrapper__1YtBN`,
	"personBg": `ShowcaseSection_personBg__l7vhR`,
	"blinkingCircles": `ShowcaseSection_blinkingCircles__y+kuh`,
	"circle": `ShowcaseSection_circle__rQZjH`,
	"blinkShowcase": `ShowcaseSection_blinkShowcase__rJ4t9`,
	"personImg": `ShowcaseSection_personImg__-txzA`,
	"screenshotWrapper": `ShowcaseSection_screenshotWrapper__TN-U3`,
	"screenshotImg": `ShowcaseSection_screenshotImg__t0rd4`,
	"partnersSection": `ShowcaseSection_partnersSection__q5IWl`,
	"partnersTitle": `ShowcaseSection_partnersTitle__Q9K8F`,
	"partnersRow": `ShowcaseSection_partnersRow__qY6PP`,
	"partnersRowInner": `ShowcaseSection_partnersRowInner__ROYsB`,
	"marquee": `ShowcaseSection_marquee__71wTS`,
	"socarTerminalImg": `ShowcaseSection_socarTerminalImg__luEkz`,
	"starRafineriImg": `ShowcaseSection_starRafineriImg__gaN4t`,
	"togImg": `ShowcaseSection_togImg__SjsQk`,
	"azImg": `ShowcaseSection_azImg__XTQ3B`,
	"tkhImg": `ShowcaseSection_tkhImg__UZ4xb`,
	"stateTaxImg": `ShowcaseSection_stateTaxImg__loM-z`,
	"bereketSigortaImg": `ShowcaseSection_bereketSigortaImg__IQt7M`,
	"bigaHomeImg": `ShowcaseSection_bigaHomeImg__BRxs1`,
	"biotrendImg": `ShowcaseSection_biotrendImg__1PHwg`,
	"doganlarHoldingImg": `ShowcaseSection_doganlarHoldingImg__oma78`,
	"doganlarMobilyaImg": `ShowcaseSection_doganlarMobilyaImg__1uwXW`,
	"dogtasImg": `ShowcaseSection_dogtasImg__L-vwN`,
	"gubretasImg": `ShowcaseSection_gubretasImg__9YraY`,
	"kelebekImg": `ShowcaseSection_kelebekImg__Bv7hC`,
	"lovaImg": `ShowcaseSection_lovaImg__1RobV`,
	"ruumStoreImg": `ShowcaseSection_ruumStoreImg__5gYqM`,
	"contentAnimate": `ShowcaseSection_contentAnimate__K5Rqt`,
	"inView": `ShowcaseSection_inView__WoveH`
};
export default ___CSS_LOADER_EXPORT___;
